module.exports = __webpack_public_path__ + "dimer/static/img/7.80f4ea2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/globalPartner/7.jpg
// module id = Al16
// module chunks = 0